import { GenerativeConstraints } from '../../types';
import { midiToFreq } from '../math';
import { SCALE_INTERVALS, ROOT_NOTE_MIDI } from './constants';

/**
 * Generate all valid MIDI notes for a given scale and octave range
 */
export function getScaleNotes(constraints: GenerativeConstraints): number[] {
    const { scale, rootNote, octaveRange } = constraints;
    const intervals = SCALE_INTERVALS[scale];
    const rootMidi = ROOT_NOTE_MIDI[rootNote];
    const notes: number[] = [];

    for (let octave = octaveRange.min; octave <= octaveRange.max; octave++) {
        intervals.forEach(interval => {
            const midiNote = (octave * 12) + rootMidi + interval;
            if (midiNote >= 0 && midiNote <= 127) {
                notes.push(midiNote);
            }
        });
    }

    return notes.sort((a, b) => a - b);
}

export function getConstrainedNote(constraints: GenerativeConstraints): number {
    const validNotes = getScaleNotes(constraints);
    if (validNotes.length === 0) return midiToFreq(60);
    const randomIndex = Math.floor(Math.random() * validNotes.length);
    return midiToFreq(validNotes[randomIndex]);
}
